// @ts-check
import { forEach } from "lodash";

import setLineItemWithForecastCells from "./setLineItemWithForecastCells";

const setGroupingsWithForecastCells = ({
  groupings,
  macroAllocations,
  columns,
  groupedByDemand,
  rootGroup,
  enableDemandRequest = false,
}) => {
  forEach(groupings, (grouping) => {
    const macroAllocationsForGrouping = macroAllocations[grouping.groupId];
    forEach(grouping.lineItems, (lineItem) => {
      setLineItemWithForecastCells({
        lineItem,
        macroAllocations: macroAllocationsForGrouping?.[lineItem.groupId],
        columns,
        rootGroup,
        enableDemandRequest,
      });
    });

    setGroupingsWithForecastCells({
      groupings: grouping.childGroupings,
      macroAllocations,
      columns,
      groupedByDemand,
      rootGroup,
      enableDemandRequest,
    });
  });
};

export default setGroupingsWithForecastCells;
